//
// Scroll to anchor links
// ===========================================================================

var adminBarHeight = $( "#wpadminbar" ).height() || 0;
var headerHeight = $( ".page__header" ).height()|| 0;
var offset = adminBarHeight + headerHeight + 30;

$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {

	if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {

		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top - offset
			}, 1000, function() {
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) {
					return false;
				} else {
					$target.attr('tabindex','-1');
					$target.focus();
				};
			});
		}

	}

});



// Scroll if selected item is not in view when the page loads but not after or during.
// First, find and get body class name that starts with hpn-
// ===========================================================================

var active_element = document.querySelector('.section__list-item--active');
if (active_element) {

	// Get position of the nav bar and the position of the link with the matching ID
	var navPosition = $('.section__list').scrollLeft(), elemPosition = $(active_element).offset().left;

    // Add the two together to get your scroll distance and animate
    $(".section__list").animate({scrollLeft: navPosition + elemPosition}, 500);

}

//
//
// ===========================================================================

function addFacetLoader() {
	$('.facetwp-template').addClass('loading');
	$('.facetwp-template').removeClass('loaded');
}

function removeFacetLoader() {
	$('.facetwp-template').addClass('loaded');
	$('.facetwp-template').removeClass('loading');
}

var facetwp = document.querySelector('.facetwp-template');

if (facetwp) {

	$(document).on('facetwp-refresh', function() {
	    addFacetLoader();
	});

	$(document).on('facetwp-loaded', function() {
		removeFacetLoader();
		$('.js-readmore').readmore({
			moreLink: '<a href="#">Se resten af anmeldelsen</a>',
			lessLink: '<a href="#">Skjul anmeldelsen</a>'
		});
	});

}
